<script>
import RingsType from '../../../../../public/assets/front/images/findjewelry/ring.svg'
import BraceletType from '../../../../../public/assets/front/images/findjewelry/bracelet.svg'
import NecklaceType from '../../../../../public/assets/front/images/findjewelry/necklace.svg'
import EarringsType from '../../../../../public/assets/front/images/findjewelry/earring.svg'
import PendantType from '../../../../../public/assets/front/images/findjewelry/earring.svg'


  const categories = [
    {
      id: '7',
      src: RingsType,
      alt: 'Rings',
    }, {
      id: '8',
      src: EarringsType,
      alt: 'Earrings',
    }, {
      id: '9',
      src: BraceletType,
      alt: 'Bracelet',
    }, {
      id: '10',
      src: NecklaceType,
      alt: 'Necklace',
    }, {
      id: '11',
      src: PendantType,
      alt: 'Pendant',
    }
  ];

  export default categories;
</script>